(function () {
  function initMarketSwitcher(switcher) {
    if (!switcher || switcher.dataset.marketReady === 'true') return;
    switcher.dataset.marketReady = 'true';

    var form = switcher.querySelector('form');
    var trigger = switcher.querySelector('[data-market-trigger]');
    var menu = switcher.querySelector('[data-market-menu]');
    var select = switcher.querySelector('[data-market-select]');
    var languageInput = switcher.querySelector('[data-market-language]');

    function closeMenu() {
      if (!trigger || !menu) return;
      trigger.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    }

    if (trigger && menu) {
      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') !== 'true';
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        menu.hidden = !open;
      });

      document.addEventListener('click', function (event) {
        if (!switcher.contains(event.target)) closeMenu();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeMenu();
      });
    }

    switcher.querySelectorAll('[data-market-option]').forEach(function (option) {
      option.addEventListener('click', function () {
        if (!form || !select) return;
        select.value = option.dataset.countryCode || '';
        if (languageInput && option.dataset.language) languageInput.value = option.dataset.language;
        form.submit();
      });
    });

    if (select) {
      select.addEventListener('change', function () {
        var selectedOption = select.options[select.selectedIndex];
        if (languageInput && selectedOption && selectedOption.dataset.language) {
          languageInput.value = selectedOption.dataset.language;
        }
        if (form) form.submit();
      });
    }
  }

  function initHeader(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    root.querySelectorAll('[data-market-switcher]').forEach(initMarketSwitcher);

    var button = root.querySelector('[data-mh-menu]');
    var mobile = root.querySelector('[data-mh-mobile]');
    if (button && mobile) {
      button.addEventListener('click', function () {
        var open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        mobile.hidden = !open;
      });
    }

    var timer = root.querySelector('[data-mh-countdown]');
    if (timer) {
      var storageKey = 'quillmore-sale-deadline';
      var deadline = Number(sessionStorage.getItem(storageKey) || 0);
      if (!deadline || deadline < Date.now()) {
        deadline = Date.now() + 7200000;
        sessionStorage.setItem(storageKey, String(deadline));
      }
      var hours = timer.querySelector('[data-mh-hours]');
      var minutes = timer.querySelector('[data-mh-minutes]');
      var seconds = timer.querySelector('[data-mh-seconds]');
      function tick() {
        var left = Math.max(0, deadline - Date.now());
        hours.textContent = String(Math.floor(left / 3600000)).padStart(2, '0');
        minutes.textContent = String(Math.floor(left % 3600000 / 60000)).padStart(2, '0');
        seconds.textContent = String(Math.floor(left % 60000 / 1000)).padStart(2, '0');
        if (left === 0) {
          deadline = Date.now() + 7200000;
          sessionStorage.setItem(storageKey, String(deadline));
        }
      }
      tick();
      setInterval(tick, 1000);
    }
  }

  document.querySelectorAll('[data-quillmore-header]').forEach(initHeader);
})();
